<script setup>
import {onMounted, ref} from 'vue'
import {Dialog, DialogPanel, DialogTitle, TransitionChild, TransitionRoot} from '@headlessui/vue'
import clientService from '@/services/ClientService';
import {useI18n} from 'vue-i18n';

const {t} = useI18n()
const isOpen = ref(true)
const props = defineProps({
  documentTemplate: {
    type: Object,
    default: () => ({})
  }
});
const emit = defineEmits(['confirm', 'cancel']);
const closeModalWith = (value) => {
  isOpen.value = false;
  setTimeout(() => {
    if (value === 'confirm') {
      emit('confirm', {fileable_type: 'App\\Models\\Client', fileable_id: selectedClient.value});
    } else {
      emit('cancel');
    }
  }, 300);
}

function openModal() {
  isOpen.value = true
}

const documentTemplate = ref({...props.documentTemplate});
const clients = ref([]);
const selectedClient = ref(0);

onMounted(() => {
  clientService.getAll('select').then(response => {
    clients.value = response;
    // prepend empty option
    clients.value.unshift({value: 0, label: t('generateDocumentTemplateModal.choose_client')});
  });
})
</script>

<template>
  <TransitionRoot appear :show="isOpen" as="template">
    <Dialog as="div"  class="modal d-block" tabindex="-1" role="dialog">
      <div class="modal-backdrop show"></div>
      <div class="modal-dialog modal-dialog-centered" style="z-index: 1055" role="document">
          <div class="modal-content">
            <DialogPanel>
              <!-- Modal Header -->
              <div class="modal-header">
                <DialogTitle as="h5" class="modal-title">
                  {{ t('generateDocumentTemplateModal.generate_document') }}
                </DialogTitle>
                <i class="btn-close cursor-pointer" @click="closeModalWith('cancel')" aria-label="Close"></i>
              </div>

              <!-- Modal Body -->
              <div class="modal-body">
                <div class="mb-3">
                  <div class="flex flex-col">
                    <label class="form-label">
                      {{ t('generateDocumentTemplateModal.client') }}
                    </label>
                    <select v-model="selectedClient" class="form-select" id="action">
                      <option :key="index" v-for="(action, index) in clients" :value="action.value">{{action.label}}</option>
                    </select>
                  </div>
                </div>
              </div>

              <!-- Modal Footer -->
              <div class="modal-footer">
                <button type="button" class="btn btn-link text-decoration-underline text-dark" @click="closeModalWith('cancel')">
                  {{ t('generateDocumentTemplateModal.cancel') }}
                </button>
                <button type="button" class="btn btn-primary" @click="closeModalWith('confirm')">
                  {{ t('generateDocumentTemplateModal.generate') }}
                </button>
              </div>
            </DialogPanel>
          </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>


